import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fechgastenprofiel, copygastenprofiel } from "../Reducers/actions";
import { message } from "../../../Reducers/loading/actions";

const GastenprofielPage = () => {
  const [loading, setLoading] = useState(true);
  const [copying, setCopying] = useState(null);
  const dispatch = useDispatch();
  const categorien = useSelector((state) => state.gastenverbruik.gastenprofielen);

  const handleCopy = (row) => {
    const newName = prompt(`Nieuwe naam voor kopie van "${row.naam}":`, `${row.naam} - Kopie`);
    if (newName) {
      setCopying(row._id);
      dispatch(copygastenprofiel({ sourceId: row._id, naam: newName }))
        .then((response) => {
          if (response.type === "SENSOR_ERROR") {
            dispatch(message(5000, "error", response.payload));
          } else {
            dispatch(message(3000, "success", "Gastenprofiel succesvol gekopieerd"));
            dispatch(fechgastenprofiel()); // Refresh the list
          }
        })
        .finally(() => setCopying(null));
    }
  };
  useEffect(() => {
    dispatch(fechgastenprofiel()).then(() => setLoading(false)).catch(() => setLoading(false));
  }, [dispatch]);

  const columns = [
    {
      dataField: "naam",
      text: "Naam",
    },
    {
      dataField: "isStandaard",
      text: "Standaard",
      formatter: (cell, row) => (
        <span className={`badge ${row.isStandaard ? "badge-success" : "badge-default"}`}>
          {row.isStandaard ? "Standaard" : ""}
        </span>
      ),
      headerStyle: { width: "100px" },
    },
    {
      dataField: "_id",
      text: "Acties",
      formatter: (cell, row) => (
        <div className="btn-group" role="group">
          <Link className="btn btn-sm btn-warning" to={`/gastenverbruik/gastenprofiel/edit/${row._id}`}>
            <i className="fa fa-edit"></i> Wijzigen
          </Link>
          <button 
            className="btn btn-sm btn-info" 
            onClick={() => handleCopy(row)}
            disabled={copying === row._id}
          >
            <i className="fa fa-copy"></i> {copying === row._id ? 'Kopiëren...' : 'Kopiëren'}
          </button>
        </div>
      ),
      headerStyle: { width: "220px" },
    },
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Gasten Profiel</h3>
        <div className="box-tools pull-right">
          <Link className="btn btn-primary btn-sm" to="/gastenverbruik/gastenprofiel/insert">
            <i className="fa fa-plus"></i>&nbsp; Gastenprofiel Toevoegen
          </Link>
        </div>
      </div>
      <div className="box box-default">
        <div className="row">
          <div className="col-md-12">
            <div className="box box-primary">
              <div className="box-body">
                {loading ? (
                  <p>Laden...</p>
                ) : (
                  <BootstrapTable
                    wrapperClasses="table-responsive-md"
                    keyField="_id"
                    data={categorien || []}
                    columns={columns}
                    pagination={paginationFactory()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GastenprofielPage;